export const getVersionName = ({ version }: { version: number }): string => {
  if (version === 0) {
    return 'Initial version';
  }

  return `Version ${version}`;
};
